import ObjectStatiService from '@/api/objectstati';

export default {
	state: {
		stati: [],
		loading: false,
		fetched: false,
	},

	mutations: {
		setStatiList(state, stati) {
			state.stati = stati;
			state.loading = false;
			state.fetched = true;
		},
		setStatiLoadingState(state, loading) {
			state.loading = loading;
		},
	},
	actions: {
		getStatiList({ commit, state }) {
			if (state.fetched) {
				return Promise.resolve(state.stati);
			}

			const pkmUNameMap = {
				1: 'entwurf',
				2: 'online',
				3: 'kopiert',
				4: 'gelöscht',
				5: 'archiv',
				6: 'synchronize',
				8: 'unknown',
				9: 'templateset',
			};

			return new Promise((resolve, reject) => {
				commit('setStatiLoadingState', true);

				ObjectStatiService.get()
				.then((response) => {
					const sortedStatis =
						Object.keys(response)
						.map((statiKey) => {
							const status = response[statiKey];
							/* Einmal direkt nach dem Anfragen die Großschreibweise setzen */
							status.S_Status_Uppercase =
								`${status.S_Status.substr(0, 1).toUpperCase()}${status.S_Status.substr(1)}`;
							/* Vergabe eines eindeutigen Namens auf Basis der StatusIDs,
							   um Umbenennungen zu überstehen */
							status.S_Key =
								pkmUNameMap[status.PKM_Status] ?
									pkmUNameMap[status.PKM_Status] : status.S_Status;

							status.PKM_Status = parseInt(status.PKM_Status, 10);
							return status;
						})
						.sort((a, b) => parseInt(a.U_Reihenfolge, 10) - parseInt(b.U_Reihenfolge, 10));
					commit('setStatiList', sortedStatis);
					resolve(response);
				})
				.catch((e) => {
					commit('setStatiLoadingState', false);
					reject(e);
				});
			});
		},
	},
	getters: {
		mappedStati(state) {
			return state.stati.map(status =>
				({
					id: status.PKM_Status,
					name: status.S_Status_Uppercase,
				}),
			)
			.sort((a, b) => (parseInt(a.id, 10) - parseInt(b.id, 10)));
		},
		statiAssoc(state) {
			return state.stati.reduce((carry, status) => {
				carry[status.S_Key] = status.PKM_Status;
				return carry;
			}, {});
		},
		statiKey(state) {
			return state.stati.reduce((carry, status) => {
				carry[status.PKM_Status] = status;
				return carry;
			}, {});
		},
		dashboardStati(state) {
			return (state.stati || []).filter(status => (status.B_Dashboard_Dropdown === 'j'));
		},
		setupStati(state) {
			return (state.stati || []).filter(status => (status.B_Setup_Dropdown === 'j'));
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/modules/objectstati.js